import React from 'react';
import { useTranslation } from 'react-i18next';

const useTranslateMethod = (slovakVersion, englishVersion) => {
  const { i18n } = useTranslation();

  return i18n.language === 'en' ? englishVersion : slovakVersion;
};

export default useTranslateMethod;
